import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { PlatformService } from '../../../services/platform/platform.service';
import { ERoutes } from '../../enums/routes.enum';

export const mobileOnlyGuard: CanActivateChildFn = (route, state) => {
  const platform = inject(PlatformService);
  const router = inject(Router);

  if (!platform.isPlatformBrowser()) {
    return true;
  }

  if (window.innerWidth <= 768) {
    return true;
  }

  // On desktop: redirect to the desktop equivalent (strip /m prefix)
  const fallbackUrl = state.url?.startsWith('/m')
    ? state.url.replace(/^\/m/, '') || '/'
    : `/${ERoutes.chat}`;

  return router.parseUrl(fallbackUrl);
};
